export default __webpack_public_path__ + "ac3bd97867c8858199abc7ffc8e10b8d.png";